import { Capacitor } from "@capacitor/core";

export function isNativeApp() {
  try {
    return Capacitor?.isNativePlatform?.() === true;
  } catch {
    return false;
  }
}

// Configure the native shell (status bar + splash) once the web app has mounted.
// No-op on the web build. Keeps the splash -> app transition clean and the
// status bar legible against the light Nearfluence header.
export async function initNativeShell() {
  if (!isNativeApp()) return;
  const platform = Capacitor.getPlatform();

  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light }); // dark icons for the light header
    if (platform === "android") {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setBackgroundColor({ color: "#FAF9F6" });
    }
  } catch {}

  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide({ fadeOutDuration: 250 });
  } catch {}
}
